<script setup lang="ts">
const props = defineProps<{
  icon?: string
  name?: string
  class?: string
}>()
</script>

<template>
  <NuxtIcon :name="props.icon || props.name || ''" :class="props.class"/>
</template>
